import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { galleryImages } from '../data/mockData';

const Gallery = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="gallery-section">
      <div className="section-header">
        <div className="section-line red" />
        <h2 className="section-title">GALERÍA</h2>
        <div className="section-line red" />
      </div>
      <p className="section-subtitle">
        Algunos de nuestros Wrangler importados
      </p>
      <div className="gallery-wrapper">
        <button
          className="gallery-nav-btn gallery-nav-left"
          onClick={() => scroll('left')}
          aria-label="Anterior"
        >
          <ChevronLeft size={24} />
        </button>
        <div className="gallery-scroll" ref={scrollRef}>
          {galleryImages.map((image) => (
            <div key={image.id} className="gallery-card">
              <img
                src={image.url}
                alt={image.alt}
                className="gallery-image"
                loading="lazy"
              />
            </div>
          ))}
        </div>
        <button
          className="gallery-nav-btn gallery-nav-right"
          onClick={() => scroll('right')}
          aria-label="Siguiente"
        >
          <ChevronRight size={24} />
        </button>
      </div>
    </section>
  );
};

export default Gallery;
